(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgcase-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcgcase-finder')) {
    customElements.define('tcgcase-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const dataElement = this.querySelector('[data-finder-data]');
        if (!dataElement) return;
        this.data = JSON.parse(dataElement.textContent);
        this.model = this.querySelector('[data-model]');
        this.radios = [...this.querySelectorAll('[data-color]')];
        this.images = [...this.querySelectorAll('.tcgf__image')];
        this.gallery = document.createElement('div');
        this.gallery.className = 'tcgf__gallery';
        this.gallery.tabIndex = 0;
        this.gallery.setAttribute('role','region');
        this.gallery.setAttribute('aria-label',this.data.text.galleryLabel);
        this.thumbnails = this.querySelector('[data-gallery-thumbnails]');
        this.querySelector('.tcgf__image-wrap').append(this.gallery);
        this.gallery.addEventListener('scroll', () => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => this.updateGalleryControls());
        }, {passive:true});
        this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.moveGallery(-1));
        this.querySelector('[data-gallery-next]').addEventListener('click', () => this.moveGallery(1));
        this.gallery.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        this.cta = this.querySelector('[data-cta]');
        this.key = value => value.trim().replace(/\s+/g, ' ').toLowerCase();
        this.display = value => value.trim().replace(/\s+/g, ' ').replace(/^iphone/i, 'iPhone').replace(/\bpro\b/gi, 'Pro').replace(/\bmax\b/gi, 'Max');
        const models = new Map();
        this.data.products.forEach(product => product.variants.forEach(variant => models.set(this.key(variant.model), this.display(variant.model))));
        const groups = new Map();
        const requestedBrand = new URL(window.location.href).searchParams.get('phone_brand');
        const brandFilter = { iphone: 'Apple', samsung: 'Samsung', google: 'Google' }[requestedBrand];
        [...models].sort((a, b) => a[1].localeCompare(b[1], undefined, { numeric: true })).forEach(([key, label]) => {
          const brand = /^iphone/i.test(label) ? 'Apple' : /^samsung/i.test(label) ? 'Samsung' : /^google/i.test(label) ? 'Google' : 'Other';
          if (brandFilter && brand !== brandFilter) return;
          if (!groups.has(brand)) { const group = document.createElement('optgroup'); group.label = brand; groups.set(brand, group); }
          const option = document.createElement('option'); option.value = key; option.textContent = label; groups.get(brand).append(option);
        });
        ['Apple', 'Samsung', 'Google', 'Other'].forEach(brand => { if (groups.has(brand)) this.model.append(groups.get(brand)); });
        this.model.disabled = false;
        this.addEventListener('change', event => { if (event.target === this.model || event.target.matches('[data-color]')) { this.querySelector('[data-feedback]').textContent = ''; this.update(); } });
        this.querySelector('[data-add-form]').addEventListener('submit', event => this.addToCart(event));
        this.dataset.ready = 'true';
        this.update();
      }
      renderGallery(index, variant, modelLabel) {
        const browsing = !this.model.value;
        const product = this.data.products[index];
        const galleryKey = browsing ? 'browse' : index + ':' + (variant?.id || 'preview');
        if (this.galleryKey === galleryKey) return;
        this.galleryKey = galleryKey;
        const photos = [];
        const seen = new Set();
        const add = (photo, label) => {
          if (!photo?.src) return;
          const identity = new URL(photo.src,location.href).pathname;
          if (seen.has(identity)) return;
          seen.add(identity);
          photos.push({...photo,caption:label,alt:photo.alt || label});
        };
        const preview = (entry, productIndex) => {
          const image = this.images[productIndex];
          const match = entry.images?.find(photo => image?.src && new URL(photo.src,location.href).pathname === new URL(image.src,location.href).pathname);
          return match || (image?.src ? {src:image.src,alt:image.alt,width:image.width,height:image.height} : null);
        };
        if (browsing) {
          this.data.products.forEach((entry, productIndex) => {
            const first = preview(entry,productIndex);
            const samsung = (entry.images || []).filter(photo => /samsung/i.test(photo.alt || ''));
            const limit = /black edge/i.test(entry.label) ? 1 : samsung.length ? 2 : 3;
            add(first,entry.label);
            const firstPath = first?.src ? new URL(first.src,location.href).pathname : '';
            (entry.images || []).filter(photo => !photo.variantImage && !/samsung/i.test(photo.alt || '') && new URL(photo.src,location.href).pathname !== firstPath).slice(0,limit - 1).forEach(photo => add(photo,entry.label));
            samsung.slice(0,3).forEach(photo => add(photo,'Samsung · ' + entry.label));
          });
        } else {
          const first = product?.useVariantImage && variant?.image
            ? {src:variant.image,alt:variant.imageAlt,width:variant.imageWidth,height:variant.imageHeight}
            : preview(product,index);
          add(first,modelLabel + ' · ' + product.label);
          const samsungModel = /samsung/i.test(modelLabel);
          (product?.images || []).filter(photo => samsungModel ? /samsung/i.test(photo.alt || '') : !photo.variantImage && !/samsung/i.test(photo.alt || '')).forEach(photo => add(photo,(samsungModel ? 'Samsung · ' : '') + product.label));
        }
        this.photos = photos;
        this.querySelector('.tcgf__image-wrap').style.setProperty('--tcgf-preview-ratio','4 / 5');
        this.gallery.replaceChildren(...photos.map((photo,photoIndex) => {
          const image = document.createElement('img');
          image.src = photo.src; image.alt = photo.alt;
          image.width = photo.width || 1000; image.height = photo.height || 1000;
          if (!photoIndex) image.fetchPriority = 'high';
          image.loading = photoIndex ? 'lazy' : 'eager'; image.decoding = 'async';
          image.draggable = false;
          return image;
        }));
        this.thumbnails.replaceChildren(...photos.map((photo,photoIndex) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label',this.data.text.viewImage + ' ' + (photoIndex + 1) + ' · ' + photo.caption);
          const image = document.createElement('img');
          image.src = photo.thumb || photo.src.replace(/([?&])width=\d+/, '$1width=160');
          image.alt = ''; image.width = 72; image.height = 80; image.loading = 'lazy';
          button.append(image);
          button.addEventListener('click',() => this.goToGallery(photoIndex));
          return button;
        }));
        this.images.forEach(image => image.removeAttribute('data-active'));
        this.gallery.scrollLeft = 0;
        this.querySelector('[data-gallery-controls]').hidden = photos.length < 2;
        this.thumbnails.hidden = photos.length < 2;
        this.updateGalleryControls();
      }
      updateGalleryControls() {
        const count = this.gallery.children.length;
        const index = Math.max(0,Math.min(count - 1,Math.round(this.gallery.scrollLeft / (this.gallery.clientWidth || 1))));
        this.querySelector('[data-gallery-count]').textContent = count ? (index + 1) + ' / ' + count : '';
        this.querySelector('[data-gallery-prev]').disabled = index <= 0;
        this.querySelector('[data-gallery-next]').disabled = index >= count - 1;
        this.querySelector('[data-caption]').textContent = this.photos?.[index]?.caption || this.data.text.preview;
        [...this.thumbnails.children].forEach((button,photoIndex) => button.setAttribute('aria-current',String(photoIndex === index)));
      }
      goToGallery(index) {
        const bounded = Math.max(0,Math.min(this.gallery.children.length - 1,index));
        this.gallery.scrollTo({left:bounded * this.gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      moveGallery(direction) {
        const index = Math.round(this.gallery.scrollLeft / (this.gallery.clientWidth || 1)) + direction;
        this.goToGallery(index);
      }
      async addToCart(event) {
        event.preventDefault();
        if (this.busy || !this.selectedVariant) return;
        const selected = this.selectedVariant;
        this.busy = true;
        this.cta.disabled = true;
        this.cta.setAttribute('aria-busy','true');
        this.cta.setAttribute('aria-disabled','true');
        this.querySelector('[data-cta-label]').textContent = this.data.text.adding;
        const feedback = this.querySelector('[data-feedback]');
        feedback.textContent = '';
        let deferred;
        let added = false;
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          deferred = CartLinesUpdateEvent.createPromise();
          deferred.promise.catch(() => {});
          this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(selected.id),quantity:1}],promise:deferred.promise}));
          const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0,5);
          const response = await fetch(this.data.addUrl + '.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1}],sections:sectionIds,sections_url:location.pathname})});
          const result = await response.json();
          if (!response.ok || result.status) {
            const error = new Error(typeof result.description === 'string' ? result.description : this.data.text.addFailed);
            error.confirmedFailure = true;
            throw error;
          }
          added = true;
          const cartResponse = await fetch(this.data.cartUrl + '.js', {headers:{Accept:'application/json'}});
          if (!cartResponse.ok) throw new Error(this.data.text.error);
          const cart = await cartResponse.json();
          deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:this.id,itemCount:1,sections:result.sections,didError:false}});
          feedback.textContent = this.data.text.added;
          this.querySelector('[data-cart-link]').hidden = false;
        } catch(error) {
          deferred?.reject(error);
          feedback.textContent = error.confirmedFailure ? error.message : added ? this.data.text.added : this.data.text.error;
          this.querySelector('[data-cart-link]').hidden = false;
          if (added) location.assign(this.data.cartUrl);
        } finally {
          this.busy = false;
          this.cta.removeAttribute('aria-busy');
          this.update();
        }
      }
      update() {
        const text = this.data.text;
        const key = this.model.value;
        this.toggleAttribute('data-has-model', Boolean(key));
        const matches = this.data.products.map(product => product.variants.find(variant => this.key(variant.model) === key));
        let selected = this.radios.findIndex(radio => radio.checked);
        if (selected < 0 || !matches[selected]?.available) selected = matches.findIndex(variant => variant?.available);
        this.radios.forEach((radio, index) => {
          const variant = matches[index];
          radio.disabled = !key || !variant?.available;
          radio.checked = index === selected && !radio.disabled;
          radio.closest('label').querySelector('[data-color-status]').textContent = !key ? text.selectFirst : !variant ? text.notMade : variant.available ? text.available : text.soldOut;
        });
        const variant = matches[selected];
        const product = this.data.products[selected];
        const modelLabel = key ? this.model.selectedOptions[0].textContent : '';
        this.querySelector('[data-summary]').textContent = !key ? text.start : variant ? modelLabel + ' · ' + product.label + ' · ' + text.available : modelLabel + ' — ' + text.none;
        this.querySelector('[data-price]').textContent = variant?.price || '';
        this.querySelector('[data-cta-label]').textContent = !key ? text.choose : variant ? text.add + ' · ' + variant.price : text.soldOut;
        this.selectedVariant = variant?.available ? variant : null;
        const variantInput = this.querySelector('[data-variant-id]');
        variantInput.value = this.selectedVariant?.id || '';
        variantInput.disabled = !this.selectedVariant;
        this.cta.disabled = !this.selectedVariant || this.busy;
        this.cta.setAttribute('aria-disabled', String(this.cta.disabled));
        const details = this.querySelector('[data-details]');
        details.hidden = !this.selectedVariant;
        if (this.selectedVariant) details.href = variant.url;
        else details.removeAttribute('href');
        const visualIndex = selected >= 0 ? selected : 0;
        this.renderGallery(visualIndex, variant, modelLabel);

      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgcase-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcgcase-hero')) customElements.define('tcgcase-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.desktop = matchMedia('(min-width:750px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.pauseLabel = this.toggle?.textContent;
      this.onChange = () => this.sync();
      this.desktop.addEventListener('change',this.onChange);
      this.motion.addEventListener('change',this.onChange);
      this.toggle?.addEventListener('click', () => {
        if (!this.video) return;
        if (this.video.paused) { this.userPaused = false; this.play(); }
        else { this.userPaused = true; this.video.pause(); }
      });
      this.sync();
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change',this.onChange);
      this.motion?.removeEventListener('change',this.onChange);
      this.video?.pause();
      this.initialized = false;
    }
    async play() {
      try { await this.video.play(); } catch { this.removeAttribute('data-playing'); }
    }
    sync() {
      if (!this.desktop.matches || this.motion.matches) { this.video?.pause(); this.removeAttribute('data-playing'); return; }
      if (!this.video) {
        const template = this.querySelector('[data-video-template]');
        if (!template) return;
        this.querySelector('.tcgh__media').append(template.content.cloneNode(true));
        this.video = this.querySelector('video');
        this.video.muted = true;
        this.video.addEventListener('playing', () => { this.setAttribute('data-playing',''); this.toggle.hidden = false; this.toggle.textContent = this.pauseLabel; this.toggle.setAttribute('aria-label',this.pauseLabel); });
        this.video.addEventListener('pause', () => { this.toggle.textContent = '▶'; this.toggle.setAttribute('aria-label',this.getAttribute('data-play-label') || 'Play video'); });
        this.video.addEventListener('error', () => { this.removeAttribute('data-playing'); this.toggle.hidden = true; });
      }
      if (!this.userPaused) this.play();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgcase-polish"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcgcase-shipping-progress')) customElements.define('tcgcase-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.sequence = 0;
      this.render({currency:this.dataset.currency,total_price:Number(this.dataset.total)});
      const place = () => {
        const target = document.querySelector('#MainContent .cart-page') || document.querySelector('#cart-drawer .cart-drawer__inner');
        const items = target?.querySelector(':scope > cart-items-component, :scope > .cart-page__items');
        if (target && items && this.parentElement !== target) target.insertBefore(this,items);
      };
      place();
      const drawer = document.querySelector('#cart-drawer');
      const cartRegion = document.querySelector('#MainContent cart-items-component') || drawer;
      if (cartRegion) new MutationObserver(place).observe(cartRegion,{childList:true,subtree:true});
      this.refresh = async () => {
        const sequence = ++this.sequence;
        try {
          const response = await fetch(this.dataset.cartUrl,{headers:{Accept:'application/json'},cache:'no-store'});
          if (!response.ok) return;
          const cart = await response.json();
          if (sequence === this.sequence) this.render(cart);
        } catch { }
      };
      window.addEventListener('lbSECartUpdated', () => this.refresh());
      import('@shopify/events').then(({StandardEvents}) => {
        document.addEventListener(StandardEvents.cartLinesUpdate,event => event.promise?.then(()=>this.refresh()).catch(()=>{}));
      });
      drawer?.addEventListener('theme-drawer:open',()=>this.refresh());
    }
    render(cart) {
      const threshold = {EUR:5500}[cart.currency];
      this.hidden = !threshold;
      document.querySelector('#cart-drawer')?.classList.toggle('tcg-shipping-active',Boolean(threshold));
      if (!threshold) return;
      const remaining = Math.max(0,threshold-cart.total_price);
      const amount = new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:cart.currency}).format(remaining/100);
      this.querySelector('p').textContent = remaining ? this.dataset.remaining.replace('[amount]',amount) : this.dataset.reached;
      this.querySelector('progress').value = Math.min(100,Math.max(0,cart.total_price/threshold*100));
    }
  });
  window.addEventListener('lbSECartUpdated', async event => {
    if (!event.detail?.isSelleasy || !event.detail?.isAtc || !event.detail?.cart) return;
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const cart = event.detail.cart;
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0,5);
      const url = new URL(location.href);
      url.searchParams.set('sections',sectionIds.join(','));
      const response = await fetch(url,{headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const sections = await response.json();
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:cart.items.map(item=>({merchandiseId:String(item.variant_id),quantity:item.quantity})),promise:deferred.promise}));
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'tcgcase-upsell',sections,didError:false}});
    } catch(error) { console.warn('TCGCase cart refresh failed',error); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcgcase-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcgcase-story')) customElements.define('tcgcase-story',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.player = this.querySelector('video');
      this.querySelector('details').addEventListener('toggle',event => {
        if (event.target.open) this.player.play().catch(() => {});
        else this.player.pause();
      });
    }
    disconnectedCallback() { this.player?.pause(); }
  });

  } catch(e) { console.error(e); }
})();
})();
